module.exports = __webpack_public_path__ + "media/images/design/images/h2_news-25436affd1465d6f4ba9b6aad8cbea9f.png";